document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.wolf-size-finder').forEach(initSizeFinder);
});

function initSizeFinder(root) {
  var data;
  try {
    data = JSON.parse(root.getAttribute('data-size-json'));
  } catch (e) {
    return;
  }
  if (!data || !data.sizes || !data.sizes.length) return;

  var toggle = root.querySelector('.wolf-size-finder__toggle');
  var panel = root.querySelector('.wolf-size-finder__panel');
  var altura = root.querySelector('#wsf-altura');
  var peso = root.querySelector('#wsf-peso');
  var resultOut = root.querySelector('[data-out="resultado"]');
  var cuerpoGroup = root.querySelector('[data-group="cuerpo"]');
  var fitGroup = root.querySelector('[data-group="fit"]');
  var corteGroup = root.querySelector('[data-group="corte"]');

  var fixedCorte = Number(root.getAttribute('data-fixed-corte')) || 0;
  var state = { cuerpo: 0, fit: 0, corte: fixedCorte };

  toggle.addEventListener('click', function () {
    var open = !panel.hasAttribute('hidden');
    if (open) {
      panel.setAttribute('hidden', '');
      toggle.classList.remove('is-open');
    } else {
      panel.removeAttribute('hidden');
      toggle.classList.add('is-open');
    }
  });

  function bindGroup(group, key) {
    group.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state[key] = Number(btn.getAttribute('data-val'));
        group.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        compute();
      });
    });
  }
  bindGroup(cuerpoGroup, 'cuerpo');
  bindGroup(fitGroup, 'fit');
  if (corteGroup) {
    bindGroup(corteGroup, 'corte');
  }

  function center(min, max) {
    return (min + max) / 2;
  }
  function span(min, max) {
    return Math.max((max - min) / 2, 1);
  }

  function parseNumber(raw) {
    if (!raw) return NaN;
    return parseFloat(raw.replace(',', '.').trim());
  }

  function compute() {
    var hInput = parseNumber(altura.value);
    var w = parseNumber(peso.value);

    if (isNaN(hInput) || isNaN(w) || hInput <= 0 || w <= 0) {
      resultOut.textContent = '—';
      return;
    }

    var h = hInput > 10 ? hInput : hInput * 100;

    var best = 0;
    var bestScore = Infinity;

    data.sizes.forEach(function (s, i) {
      var dh = (h - center(s.altura_min, s.altura_max)) / span(s.altura_min, s.altura_max);
      var dw = (w - center(s.peso_min, s.peso_max)) / span(s.peso_min, s.peso_max);
      var score = dh * dh + dw * dw;
      if (score < bestScore) {
        bestScore = score;
        best = i;
      }
    });

    var idx = best + state.cuerpo * 0.5 + state.fit;
    idx = Math.round(idx);
    idx = Math.max(0, Math.min(data.sizes.length - 1, idx));

    if (state.corte === 1) {
      idx = Math.max(0, idx - 1);
    }

    resultOut.textContent = data.sizes[idx].talle;
  }

  altura.addEventListener('input', compute);
  peso.addEventListener('input', compute);
  compute();
}